var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "gryph-on.myshopify.com",
        "incentive": {
            "type": "fixed_amount",
            "value": "10.00",
            "price_rule_id": "",
            "coupon": ""
        },
        "program": "OTE0NTQ="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Share Gryphon. Earn Rewards.",
            "refer_background_color": "#172442",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-center"
        },
        "refer_customer_invite": {
            "popup_header": "Share Gryphon. Earn Rewards.",
            "popup_description": "Share an invite link with friends and they'll get $10.00 OFF their Gryphon website purchase. For every referral, you'll be paid 10% of the total order value!",
            "button_text_get_invite": "Get Invite Link",
            "button_copy_invite": "Copy Invite Link",
            "popup_background_color": "#172442",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "Get $10 OFF",
            "shop_description": "Congrats! Your friend has gifted you a coupon, which will be automatically applied during your checkout.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#172442",
            "shop_text_color": "#ffffff"
        }
    }
}